module.exports = __webpack_public_path__ + "static/media/services_prevnext_arrow.521d0567.svg";